import clientApi from '@/api/client'

export const SET_CLIENTS = 'SET_CLIENTS'
export const CLEAR_CLIENTS = 'CLEAR_CLIENTS'
export const REMOVE_CLIENT = 'REMOVE_CLIENT'
export const ADD_CLIENT = 'ADD_CLIENT'

const state = {
  clients: {
    clients: [],
    total: {}
  }
}
const getters = {
  getterClients: state => state.clients
}
const mutations = {
  [SET_CLIENTS] (state, values) {
    state.clients = values
  },
  [CLEAR_CLIENTS] (state) {
    state.clients = {
      clients: [],
      total: {}
    }
  },
  [REMOVE_CLIENT] (state, values) {
    const clientIndex = state.clients.clients.findIndex((val) => {
      return val.clientid === values.clientid
    })

    if (clientIndex > -1) {
      state.clients.clients.splice(clientIndex, 1)
    }
  },
  [ADD_CLIENT] (state, values) {
    state.clients.clients.unshift(values)
  }
}
const actions = {
  actionGetUnlinkedClients ({ commit }, params) {
    return clientApi.getAllUnlinkedClients(params)
      .then((response) => {
        commit(SET_CLIENTS, response.data)
        return Promise.resolve(response.data)
      })
      .catch((e) => {
        return Promise.reject(e.data)
      })
  },
  actionUpdateClientIesAlias (_, params) {
    return clientApi.updateClientIesAlias(params)
      .then((response) => {
        return Promise.resolve(response.data)
      })
      .catch((e) => {
        return Promise.reject(e.data)
      })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
